/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiPoseFromJSON, StreemApiPoseToJSON, WallItemARElementFromJSON, WallItemARElementToJSON, } from './';
export function WallItemSceneshotFromJSON(json) {
    return WallItemSceneshotFromJSONTyped(json, false);
}
export function WallItemSceneshotFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'meshSid': !exists(json, 'mesh_sid') ? undefined : json['mesh_sid'],
        'previewStorageUrl': !exists(json, 'preview_storage_url') ? undefined : json['preview_storage_url'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'pose': !exists(json, 'pose') ? undefined : StreemApiPoseFromJSON(json['pose']),
        'arElements': !exists(json, 'ar_elements') ? undefined : (json['ar_elements'].map(WallItemARElementFromJSON)),
    };
}
export function WallItemSceneshotToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mesh_sid': value.meshSid,
        'preview_storage_url': value.previewStorageUrl,
        'name': value.name,
        'pose': StreemApiPoseToJSON(value.pose),
        'ar_elements': value.arElements === undefined ? undefined : (value.arElements.map(WallItemARElementToJSON)),
    };
}
//# sourceMappingURL=WallItemSceneshot.js.map